import { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

interface DataTableFloatingBarProps<
  TData,
> extends React.ComponentPropsWithoutRef<"div"> {
  table: Table<TData>;
}

export function DataTableFloatingBar<TData>({
  table,
  children,
  ...props
}: DataTableFloatingBarProps<TData>) {
  const [translate] = useTranslation(["core"]);
  const selectedCount = Object.keys(table.getState().rowSelection).length;

  return (
    <div
      className="absolute z-10 flex items-center justify-center transform -translate-x-1/2 left-1/2 animate-floatBottom top-[30%] min-w-[90%]"
      {...props}
    >
      <div className="px-4 py-4 rounded-full transition-transform duration-500 ease-in-out bg-neutral-700">
        <div className="flex items-center text-sm text-neutral-400">
          <p className="pr-4">
            {translate("data-table-floating-bar-selected", {
              count: selectedCount,
            })}
          </p>
          <div className="flex flex-col gap-1 text-white md:flex-row md:gap-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
